import { Divider as MUIDivider, DividerProps } from "@mui/material";
import { theme } from "$utils/theme/bataillog";

function Divider({ ...props }: DividerProps) {
  return (
    <MUIDivider
      {...props}
      style={{ marginBottom: theme.spacing(3), marginTop: theme.spacing(3) }}
    />
  );
}

export default Divider;
